"use strict";

var keySearch = {
    'by_broadcaster': 1,
    'by_channel': 3,
     null: 3
};

export default (data, filter, viewTab, activeFilter, useTreeTabMode = false) => data.filter(
    s => filter ? s.station_name.match(new RegExp(filter + "|Reporting Universe" + "|Total TV", "i")) : true
).filter(
    s => keySearch[viewTab] ? (s.channel_type.match(new RegExp("^" + keySearch[viewTab] + "|0", "i")) || activeFilter === false) : true
).
map(
    (row, i) => {
        let rowClass = "";
        let nullValueSymbol = "-";
        let blockedStations = {
            "Reporting Universe" : true,
            "Total TV": true
        };

        if (row.station_id in blockedStations) {
            rowClass = blockedStations[row.station_id] === true
                ? "no-sort summary"
                : "no-sort";

            nullValueSymbol = blockedStations[row.station_id] === true
                ? ""
                : "-";
        } else {
            rowClass = "standard";
        }

        if (!useTreeTabMode) {
            return `<tr data-channel-type="${(row.channel_type)}" id="station_${row.station_id}" class="${rowClass}">` +
                `<td>${row.station_name}</td>` +
                `<td class="number align_right bleft-white c7tv">${(row.bcaster_weekly_reach_val) ? row.bcaster_weekly_reach_val.toLocaleString() : nullValueSymbol}</td>` +
                `<td class="percentage align_right c7tv">${(row.bcaster_weekly_reach_perc) ? row.bcaster_weekly_reach_perc.toLocaleString() : nullValueSymbol}</td>` +
                `<td class="share align_right c7tv">${(row.bcaster_weekly_share_val) ? row.bcaster_weekly_share_val.toLocaleString() : nullValueSymbol}</td>` +
                `<td class="minutage align_right c7tv">${(row.bcaster_avg_daily_minutes_val) ? row.bcaster_avg_daily_minutes_val.toLocaleString() : nullValueSymbol}</td>` +
                `<td class="number align_right bleft-white ttsv">${(row.channel_weekly_reach_val) ? row.channel_weekly_reach_val.toLocaleString() : nullValueSymbol}</td>` +
                `<td class="percentage align_right ttsv">${(row.channel_weekly_reach_perc) ? row.channel_weekly_reach_perc.toLocaleString() : nullValueSymbol}</td>` +
                `<td class="share align_right ttsv">${(row.channel_weekly_share_val) ? row.channel_weekly_share_val : nullValueSymbol}</td>` +
                `<td class="minutage align_right ttsv">${(row.channel_avg_daily_minutes_val) ? row.channel_avg_daily_minutes_val.toLocaleString() : nullValueSymbol}</td>` +
                `</tr>`;
        } else {
            return `<tr data-channel-type="${(row.channel_type)}" id="station_${row.station_id}" class="${rowClass}">` +
                `<td>${row.station_name}</td>` +
                `<td class="number align_right bleft-white tbv">${(row.bcaster_weekly_reach_val) ? row.bcaster_weekly_reach_val.toLocaleString() : nullValueSymbol}</td>` +
                `<td class="percentage align_right tbv">${(row.bcaster_weekly_reach_perc) ? row.bcaster_weekly_reach_perc.toLocaleString() : nullValueSymbol}</td>` +
                `<td class="share align_right tbv">${(row.bcaster_weekly_share_val) ? row.bcaster_weekly_share_val.toLocaleString() : nullValueSymbol}</td>` +
                `<td class="minutage align_right tbv">${(row.bcaster_avg_daily_minutes_val) ? row.bcaster_avg_daily_minutes_val.toLocaleString() : nullValueSymbol}</td>` +

                `<td class="number align_right bleft-white tiv">${(row.channel_weekly_reach_val) ? row.channel_weekly_reach_val.toLocaleString() : nullValueSymbol}</td>` +
                `<td class="percentage align_right tiv">${(row.channel_weekly_reach_perc) ? row.channel_weekly_reach_perc.toLocaleString() : nullValueSymbol}</td>` +
                `<td class="share align_right tiv">${(row.channel_weekly_share_val) ? row.channel_weekly_share_val : nullValueSymbol}</td>` +
                `<td class="minutage align_right tiv">${(row.channel_avg_daily_minutes_val) ? row.channel_avg_daily_minutes_val.toLocaleString() : nullValueSymbol}</td>` +
                // zmienic tu na odpowiednie nazwy
                `<td class="number align_right bleft-white tsv">${(row.svod_weekly_reach_val) ? row.svod_weekly_reach_val.toLocaleString() : nullValueSymbol}</td>` +
                `<td class="percentage align_right tsv">${(row.svod_weekly_reach_perc) ? row.svod_weekly_reach_perc.toLocaleString() : nullValueSymbol}</td>` +
                `<td class="share align_right tsv">${(row.svod_weekly_share_val) ? row.svod_weekly_share_val : nullValueSymbol}</td>` +
                `<td class="minutage align_right tsv">${(row.svod_avg_daily_minutes_val) ? row.svod_avg_daily_minutes_val.toLocaleString() : nullValueSymbol}</td>` +
                `</tr>`;
        }
    }
).join("\n");
